/**
 * DEFERRABLE type to be used to specify if foreign key constraints can be deferred.
 */
export type DeferrableType = "INITIALLY IMMEDIATE" | "INITIALLY DEFERRED"
